import { yupResolver } from "@hookform/resolvers/yup";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputLabel,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import MDInput from "components/MDInput";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { CitiesDialogValidation } from "util/validations/commonValidations";
import { addCity } from "../Redux/actionCreator";
import MDButton from "./../../../components/MDButton/index";
import { getProfessions } from "../../../shared/services";
import { setProfessionType } from "layouts/events/Redux/actionCreator";

import CloseIcon from "@mui/icons-material/Close";

const ROW_HEIGHT = 56;
const MAX_VISIBLE_ROWS = 3;

const valueTypeMap = {
  percentage: "AbsoluteByPercentage",
  value: "AbsoluteByValue",
};
const AddNewCityDialogContent = ({ handleDialogClose }) => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(CitiesDialogValidation),
  });
  const { Profession_Type_Data } = useSelector((state) => state.events);
  const professionData = Profession_Type_Data?.professionInfo || [];

  // build profession list
  const professionOptions = professionData.map((p) => ({
    key: p._id,
    value: p.name,
  }));

  const [monetizationType, setMonetizationType] = useState({});

  // set default monetization type
  useEffect(() => {
    const defaults = {};
    professionOptions.forEach((p) => {
      defaults[p.key] = "percentage";
    });
    setMonetizationType(defaults);
  }, [professionOptions.length]);

  // fetch professions
  useEffect(() => {
    dispatch(setProfessionType());
  }, []);

  // 🔥 FIXED TRANSFORM FUNCTION
  const buildDefaultMonetization = (monetization = {}) => {
    return Object.keys(monetization)
      .filter((professionId) => monetization[professionId]?.value !== undefined)
      .map((professionId) => ({
        professionType: professionId, // ✅ ObjectId directly
        valueType: valueTypeMap[monetization[professionId].type],
        value: Number(monetization[professionId].value),
      }));
  };

  const onSubmit = (data) => {
       const payload = {
         name: data.name,
         isLaunched: data.isLaunched,
         defaultMonetization: buildDefaultMonetization(data.monetization),
       };

       console.log("FINAL PAYLOAD 👉", payload);

       dispatch(addCity(payload));

    // dispatch(addCity(data));

    handleDialogClose();
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={1}>
          {/* Name */}
          <Grid item xs={4}>
            <InputLabel fullWidth className="input-labels">
              Name
            </InputLabel>
          </Grid>

          <Grid item xs={8}>
            <MDInput
              placeholder=""
              sx={{ width: "100%", marginTop: "0.4rem" }}
              inputProps={{
                style: { fontSize: 15, fontWeight: "bold" },
              }}
              {...register("name")}
              error={errors?.name?.message}
              helperText={errors?.name?.message}
            />
          </Grid>

          {/* make monetization input */}
          <Grid item xs={12} sx={{ mt: 2 }}>
            <div
            // style={{
            //   border: "1px solid #e0e0e0",
            //   borderRadius: "8px",
            //   padding: "12px",
            //   background: "#f5f5f5",
            // }}
            >
              {/* Header */}
              <Grid container sx={{ fontWeight: "bold", mb: 1 }}>
                <Grid item xs={4}>
                  Profession
                </Grid>
                <Grid item xs={4}>
                  Type
                </Grid>
                <Grid item xs={4}>
                  Value
                </Grid>
              </Grid>

              {/* Scroll */}
              <div
                style={{
                  maxHeight: ROW_HEIGHT * MAX_VISIBLE_ROWS,
                  overflowY: "auto",
                }}
              >
                {professionOptions.map((item) => (
                  <Grid
                    container
                    spacing={1}
                    alignItems="center"
                    key={item.key}
                    sx={{ mb: 2 }}
                  >
                    <Grid item xs={4}>
                      {item.value}
                    </Grid>
                    <Grid item xs={4}>
                      <Controller
                        name={`monetization.${item.key}.type`}
                        control={control}
                        defaultValue="percentage"
                        render={({ field }) => (
                          <MDInput
                            select
                            fullWidth
                            SelectProps={{ native: true }}
                            {...field}
                            onChange={(e) => {
                              field.onChange(e);
                              setMonetizationType((prev) => ({
                                ...prev,
                                [item.key]: e.target.value,
                              }));
                            }}
                          >
                            <option value="percentage">Percentage</option>
                            <option value="value">Value</option>
                          </MDInput>
                        )}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Controller
                        name={`monetization.${item.key}.value`}
                        control={control}
                        render={({ field }) => (
                          <MDInput
                            {...field}
                            // type="number"
                            type="text"
                            fullWidth
                            placeholder={
                              monetizationType[item.key] === "value"
                                ? "Enter value"
                                : "Enter %"
                            }
                            inputProps={{
                              inputMode: "decimal",
                            }}
                            // onChange={(e) => {
                            //   const value = e.target.value;
                            //   if (/^\d*\.?\d*$/.test(value)) {
                            //     field.onChange(value);
                            //   }
                            // }}

                            onChange={(e) => {
                              const value = e.target.value;

                              if (!/^\d*\.?\d*$/.test(value)) return;

                              if (
                                monetizationType[item.key] === "percentage" &&
                                value !== "" &&
                                Number(value) > 100
                              ) {
                                return;
                              }

                              field.onChange(value);
                            }}
                          />
                        )}
                      />
                      {errors?.monetization?.[item.key]?.value?.message && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginBottom: "-18px",
                          }}
                        >
                          {errors?.monetization?.[item.key]?.value?.message}
                        </div>
                      )}
                    </Grid>
                  </Grid>
                ))}
              </div>
            </div>
          </Grid>

          {/* is Launched */}
          <Grid item xs={10} md={10}>
            <Grid item xs={6} sx={{ marginLeft: "1rem" }}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Controller
                      defaultValue={false}
                      name="isLaunched"
                      control={control}
                      render={({ field: props }) => (
                        <Checkbox
                          {...props}
                          checked={props.value}
                          onChange={(e) => props.onChange(e.target.checked)}
                        />
                      )}
                    />
                  }
                  label="Is Launched"
                />
              </FormGroup>
            </Grid>
          </Grid>
        </Grid>
        <MDButton
          variant="contained"
          color="info"
          type="submit"
          sx={{ marginTop: "1.5rem" }}
        >
          create
        </MDButton>
      </form>
    </div>
  );
};

export default AddNewCityDialogContent;
